<template>
  <div class="message-row">
    <div class="subscription-col ">
      <span class="message-name">{{messageName}}</span>
    </div>
    <div class="subscription-col">
      
    </div>
    <div class="subscription-col">
      <input type="checkbox" v-model="isSubscribed" @change="toggleBoardSubscription">
    </div>
  </div>
</template>

<script>
import api from '../../../api/api';

export default {
  props: ['message'],
  data() {
    return {
      messageName: '',
      messageId: null,
      isSubscribed: false,
    }
  },
  created() {
    this.messageName = this.message.receivedUserName;
    this.messageId = this.message.receivedUserId;
    this.isSubscribed = this.message.subscribed;
  },
  watch: {
    message(newValue) {
      this.messageName = newValue.receivedUserName;
      this.messageId = newValue.receivedUserId;
      this.isSubscribed = newValue.subscribed;
    }
  },
  methods: {
    toggleBoardSubscription() {
      if(this.isSubscribed === true) {
        api.post('/Subscription/messages', {
          userID: this.messageId,
        }).catch(() => {
          this.isSubscribed = !this.isSubscribed;
        }).finally(() => {
          this.$emit('refreshdata');
        });
      }
      else{
        api.delete('/Subscription/messages', {
          userID: this.messageId,
        }).catch(() => {
          this.isSubscribed = !this.isSubscribed;
        }).finally(() => {
          this.$emit('refreshdata');
        });
      }
    }
  }
}
</script>
